module.exports = __webpack_public_path__ + "static/media/brego35923.a897b399.jpg";